module.exports = __webpack_public_path__ + "img/PRNT_00_mono_green_T-1.605dcc5b.png";